import React, { useMemo } from "react";
import { useSelector } from "react-redux";

import { Select } from "@mui/material";
import { Grid, MenuItem } from "@mui/material";
import FormSelectField from "components/FormFields/FormSelect";

import { checkIsRpmManufacturer } from "utils/rpmDevice.util";
import {
  checkIsIDTFBilling,
  getRemoteBillingDiagnosisMapper,
} from "utils/billingCode.util";

import {
  ADDITIONAL_BILLING_CODES,
  DIAGNOSIS_CODES_BY_RPM_BILLING_CODES,
  IN_OFFICE_DIAGNOSIS_CODES_BY_BILLING_CODES,
} from "static/constants";
import FormAutoComplete from "components/FormFields/FormAutoComplete";

const BillingDiagnosisCodeForm = ({ isLoading, handleCodeChange }) => {
  const { reportDetail, billingDiagnosisCodes, reportAccountDetail } =
    useSelector((state) => state.transmission);

  const isIDTFBilling = checkIsIDTFBilling({
    account: reportAccountDetail,
    patient: reportDetail?.patient,
  });

  const billingDiagnosisCodeMapper = useMemo(() => {
    return reportDetail?.transmissionType === "inOffice"
      ? IN_OFFICE_DIAGNOSIS_CODES_BY_BILLING_CODES
      : checkIsRpmManufacturer(reportDetail?.manufacturer)
        ? DIAGNOSIS_CODES_BY_RPM_BILLING_CODES
        : getRemoteBillingDiagnosisMapper(isIDTFBilling);
  }, [
    reportDetail?.manufacturer,
    reportDetail?.transmissionType,
    isIDTFBilling,
  ]);

  return billingDiagnosisCodes?.map((code, index) => (
    <Grid container key={`${code.billingCode}_${index}`} className="mt-2">
      <Grid item xs={3} className="gridItem">
        <span className="gridItem-title">BILLING CODE</span>
        <span className="gridItem-subTitle">{code.billingCode}</span>
      </Grid>

      <Grid item xs={9} style={{ boxSizing: "border-box" }}>
        {reportDetail?.account === "Pueblo Cardiology Associates" ? (
          <FormAutoComplete
            maxLength={15}
            required={true}
            className="mt-2"
            label="Diagnosis Code"
            value={code.diagnosisCode}
            hasError={!code.diagnosisCode}
            options={billingDiagnosisCodeMapper?.[code.billingCode]?.map(
              (diagnosisCode) => diagnosisCode
            )}
            handleInputChange={(selectedDiagnosisCode = null) => {
              handleCodeChange(index, selectedDiagnosisCode.toUpperCase());
            }}
          />
        ) : (
          <FormSelectField
            label="Diagnosis Code"
            required={true}
            disabled={isLoading}
            hasError={!code.diagnosisCode}
            customMapping={
              <Select
                id={`diagnosisCode_${index}`}
                value={code.diagnosisCode}
                label="Diagnosis Code"
                onChange={(e) => handleCodeChange(index, e.target.value)}
                disabled={Object.values(ADDITIONAL_BILLING_CODES)
                  ?.flat()
                  ?.includes(code.billingCode)}
              >
                {billingDiagnosisCodeMapper?.[code.billingCode]?.map((code) => (
                  <MenuItem value={code} key={code}>
                    {code}
                  </MenuItem>
                ))}
              </Select>
            }
          />
        )}
      </Grid>
    </Grid>
  ));
};

export default BillingDiagnosisCodeForm;
